// extracted by mini-css-extract-plugin
export default {"wrapper":"ChooseToday_wrapper__-GAvP","title":"ChooseToday_title__kB2NH","list":"ChooseToday_list__GG-Du","item":"ChooseToday_item__kVZ9L"};